// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SDPCb","icon":"styles_icon__kyjXF"};